import ScriptInjectionUtils from '@/modules/externalScripts/utils/scriptInjectionUtils';
import eventListenerService from '@/utils/eventCommunicationUtils/eventListenerService';
import Vue from 'vue';

const isPendoDenied = () => Vue.prototype.$hasFeature('pkg.bus.pendo.deny');

/**
 * Initialize Pendo based on data received from Angular
 */
const buildPendo = (apiKey) => {
  if (!apiKey) return;

  const pendoScriptId = 'pov_pendo';
  const script = `(function(apiKey){ (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[]; v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){ o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]); y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js'; z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo'); })('${apiKey}');`;
  ScriptInjectionUtils.injectScriptToMainDom(script, pendoScriptId);
};

const initPendo = ({ visitor, account }) => {
  if (window.pendo) {
    window.pendo.initialize({ visitor, account });
  }
};

/**
 * Initializes Pendo if feature flags are loaded and pendo is not denied.
 * Uses the current state.pendoData from the store module.
 */
function initializePendoIfAllowed(pendoData) {
  if (!isPendoDenied()) {
    if (pendoData && pendoData.pendo) {
      const isMobile = Vue.prototype.$hasFeature('isMobile') || Vue.prototype.$hasFeature('isMobileApp');
      const pendoAPIkey = isMobile ? pendoData.pendo.mobile : pendoData.pendo.desktop;
      buildPendo(pendoAPIkey);
      initPendo({ visitor: pendoData.visitor, account: pendoData.account });
    }
  }
}

/**
 * Subscribes to the featureFlagsLoaded event and initializes Pendo if allowed.
 * Call this once after the store is loaded, passing a getter for pendoData.
 * Example: subscribeToFeatureFlags(() => state.pendoData)
 */
function subscribeToFeatureFlags(getPendoData) {
  function handleFlagsLoaded() {
    initializePendoIfAllowed(getPendoData());
    eventListenerService.removeListener('featureFlagsLoaded', handleFlagsLoaded);
  }

  eventListenerService.addListener('featureFlagsLoaded', handleFlagsLoaded);

  // Immediate callback if already loaded
  if (Vue.prototype.$featureFlagsLoaded && Vue.prototype.$featureFlagsLoaded()) {
    handleFlagsLoaded();
  }
}

export default {
  buildPendo,
  initPendo,
  subscribeToFeatureFlags,
  isPendoDenied,
};
